'use strict';

// 
// Class for managing the mobile menu.
// 

var _ = require('underscore');
var $ = require('./functions');

module.exports = {

	el: $.el('.paralax-me'),

	init: function() {
		_.each(this.el, function ( el ) {
			$.addEventListener( window, 'scroll', _.bind( this.scroll, this, el ) );
		}, this);
	},

	scroll: function( el ) {
		var pos = window.scrollY;
		if ( pos < el.dataset.scrollstart )
			return;
		if ( pos > el.dataset.scrollstop )
			return;
		var yPos = -( pos / el.dataset.scrollspeed);
		el.style[el.dataset.scrollproperty] = yPos + "px";
	}
}
